
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/digital-tools",
      function () {
        return require("private-next-pages/digital-tools.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/digital-tools"])
      });
    }
  